import { cn } from "@/utils/cn";
import { memo } from "react";

interface LightningBoltIconProps {
  className?: string;
}

export const LightningBoltIcon = memo(function LightningBoltIcon({
  className,
}: LightningBoltIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="23"
      viewBox="0 0 17 23"
      fill="none"
      aria-hidden="true"
      className={cn(className)}
    >
      <path
        d="M16.4847 10.3247C16.4563 10.2045 16.3987 10.0931 16.3169 10.0006C16.2351 9.908 16.1318 9.83707 16.016 9.79406L10.615 9.76812L11.9894 0.893431C12.0205 0.7337 11.9989 0.568182 11.9277 0.421851C11.8565 0.27552 11.7396 0.156318 11.5947 0.082232C11.4498 0.00814581 11.2848 -0.0168043 11.1244 0.0111466C10.9641 0.0390974 10.8173 0.118433 10.706 0.237181L0.205988 11.4872C0.120708 11.577 0.0590157 11.6866 0.0264224 11.8061C-0.0061709 11.9257 -0.00865008 12.0514 0.0192066 12.1721C0.0470632 12.2928 0.104388 12.4048 0.186059 12.4979C0.267731 12.5911 0.371205 12.6625 0.487238 12.7059L5.89005 12.7319L4.51943 21.5991C4.4883 21.7588 4.50998 21.9243 4.58118 22.0706C4.65238 22.217 4.76925 22.3362 4.91414 22.4103C5.05903 22.4843 5.22409 22.5093 5.3844 22.4813C5.54472 22.4534 5.69159 22.3741 5.80286 22.2553L16.3029 11.0053C16.3866 10.9154 16.447 10.8064 16.4787 10.6877C16.5104 10.569 16.5125 10.4443 16.4847 10.3247ZM6.50786 19.3087L7.48943 12.3981C7.52456 12.224 7.49672 12.043 7.41087 11.8874C7.32503 11.7319 7.18675 11.6119 7.02068 11.5487L2.06693 11.6878L10 3.18843L9.01943 10.0991C8.98429 10.2732 9.01213 10.4542 9.09798 10.6097C9.18382 10.7653 9.3221 10.8853 9.48818 10.9484L14.4382 10.8047L6.50786 19.3087Z"
        fill="#620AD5"
      />
    </svg>
  );
});
